/* global axios */
import ApiClient from '../ApiClient';

class CRMProductsAPI extends ApiClient {
  constructor() {
    super('crm/products', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(productData) {
    return axios.post(this.url, productData);
  }

  update(id, productData) {
    return axios.patch(`${this.url}/${id}`, productData);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CRMProductsAPI();
